import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    servicesSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <section id="home" className="hero-section">
        {/* Video Background */}
        <div className="hero-video-background">
          <video 
            autoPlay 
            loop 
            muted 
            playsInline
            className="hero-video"
          >
            <source src="https://videos.pexels.com/video-files/8359173/8359173-uhd_2560_1440_25fps.mp4" type="video/mp4" />
          </video>
          <div className="hero-video-overlay"></div>
        </div>

        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">Dream Big. Study in Dubai.</h1>
              
              <div className="hero-buttons">
                <Button onClick={scrollToServices} className="hero-cta-primary">
                  Explore Services
                </Button>
                <Button onClick={scrollToContact} className="hero-cta-primary">
                  Get in touch
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;